import { render, staticRenderFns } from "./VFormGroup.vue?vue&type=template&id=20996a46"
import script from "./VFormGroup.vue?vue&type=script&lang=ts"
export * from "./VFormGroup.vue?vue&type=script&lang=ts"
import style0 from "./VFormGroup.vue?vue&type=style&index=0&id=20996a46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports